import { useEffect, useEffectEvent, useRef } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { LinearProgress } from "@mui/material";

import { useAppDispatch } from "../../state/hooks";
import { loadSessionInfo } from "../../state/actions/authActions";
import { persistor, RootState } from "../../state/store";
import { userAccountAjax } from "../../ajax/UserAccountAjax";
import { accountLanguageToAdopt, chooseLanguage } from "../../i18n/languageChoice";
import { readSignupRequest } from "./ssoRedirect";

const SignedInArrival: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const user = useSelector((state: RootState) => state.authReducer.user);
  const handled = useRef(false);

  const arrive = useEffectEvent(async (language: string | null | undefined) => {
    const zoneIds = readSignupRequest(location.search)?.zoneIds ?? [];
    if (zoneIds.length > 0)
      await userAccountAjax.addDemoZones(zoneIds).then(() => dispatch(loadSessionInfo())).catch(() => false);

    const adopted = accountLanguageToAdopt(language);
    if (adopted) {
      void chooseLanguage(adopted, { beforeReload: () => persistor.flush() });
      return;
    }

    navigate("/", { replace: true });
  });

  useEffect(() => {
    if (handled.current || !user) return;
    handled.current = true;
    void arrive(user.language);
  }, [user]);

  return <LinearProgress />;
};

export default SignedInArrival;
